import React, { createContext, useState, useEffect } from "react";

// Crear el contexto
const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {    
    fetch("/config/settings.json")
      .then((response) => response.json())
      .then((data) => setSettings(data))
      .catch((error) => console.error("Error cargando settings.json", error));
  }, []);

  return (
    <SettingsContext.Provider value={settings}>
      {settings ? children : <p> </p>}
    </SettingsContext.Provider>
  );
};

// Hook para acceder fácilmente al contexto
export const useSettings = () => React.useContext(SettingsContext);